export default {
  item: function item(state) {
    return state.item;
  },
  index: function index(state) {
    return state.index;
  },
  products: function products(state) {
    return state.products;
  },
  loading: function loading(state) {
    return state.loading;
  },
  items: function items(state) {
    return state.items;
  }
};